<template>
  <div class="slider" ref="mySlider" :style="{'height':barHeight}" @mousedown="sliderHandle">
    <div class="bar-line-right" :style="{'width':barHeight,'height':lineHeight}"></div>
    <div class="bar-line" :style="{'width': 'calc(100% - '+barHeight+')','height':lineHeight,'background-size':modelValue+'%'}">
      <div class="bar-handle" :style="{'width':barHeight,'height':barHeight,'left':modelValue+'%'}"></div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
props:{
  modelValue: Number,
  barHeight: {
    default: '20px'
  },
  lineHeight: {
    default: '4px'
  }
},
setup(props, { emit }){
  const mySlider = ref(null)
  const sliderHandle = (event) => {
    let x = props.barHeight.match(/(\d+)/)[1]
    x = parseInt(x)
    let temp = mySlider.value
    let tl = temp.getBoundingClientRect().left
    let tw = temp.offsetWidth
    const numRange = (n) => {
      let res = n
      let max = tw-x
      if(n<0) res= 0;
      else if(n>max) res= max;
      emit('update:modelValue',parseInt(res*100/max))
    }
    numRange(event.pageX-tl-x/2)
    document.onmousemove = (e) => {
      numRange(e.pageX - tl - x/2)
    }
    document.onmouseup = ()=>{
      document.onmousemove = null
      document.onmouseup = null
    }
  }
  return {
    sliderHandle,
    mySlider
  }
}
}
</script>

<style lang="less">
.slider{
  position: relative;
  width: 220px;
  cursor: pointer;
}
.bar-line{
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  background: -webkit-linear-gradient(#8b8b94, #8b8b94) no-repeat, rgba(255,255,255,0.12);
  background-size: 0% 100%;
  border-radius: 2px;
}
.bar-line-right{
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  background-color: rgba(255,255,255,0.12);
  border-radius: 2px;
}
.bar-handle{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  box-sizing: border-box;
  border-radius: 50%;
  background: #e8e8ec;
  box-shadow: 0 1px 4px rgba(0,0,0,0.4), 0 0 0 2px rgba(255,255,255,0.08);
  transition: box-shadow 0.2s ease;
}
.bar-handle:hover{
  box-shadow: 0 2px 8px rgba(139,139,148,0.5), 0 0 0 3px rgba(255,255,255,0.12);
}
</style>
